
import React, { Component } from 'react';
import { TreeSelect, message, Input, Modal, Icon, Spin, Tag } from 'antd';
import '../../../static/css/index.css'
import { updateUser, getOrg } from '../../../apis/api'

const TreeNode = TreeSelect.TreeNode;
const SHOW_PARENT = TreeSelect.SHOW_PARENT;

class UpdateUserPrivilege extends Component {
  constructor(props) {
    super(props);
    this.state={
        treeData: [],//组织架构数据
        childTreeData: [],//从父级获取组织架构数据
        loading:false,
        search_orgName:'',
        orgValue:[],//指定当前选中的组织架构
        scope:'',//用户权限json字符串
        scope_list:[],//权限范围
        scope_before_list:[],//之前已选择的权限范围
        params:{},//修改用户权限传的参数
        inputVisible: false,//添加标签
    }
  }

  componentDidMount(){
    this.setState({access_token:sessionStorage.getItem('access_token')})
    if(this.props.details){
        this.setState({params:this.props.details,scope_list:this.props.details.scope?JSON.parse(this.props.details.scope):'',scope_before_list:[]})
    }

  }

  
  componentWillReceiveProps(nextProps) { 
    if(nextProps.details&&nextProps.details!==this.props.details){
        this.setState({params:nextProps.details,scope_list:nextProps.details.scope?JSON.parse(nextProps.details.scope):'',scope_before_list:[]})
    }
  }

   //展示添加标签的树
   showTree = () => {
    this.setState({ inputVisible: true},()=>{
      this.getOrgApi(0);
    });
  }

  //关闭标签
  handleClose = (removedTag) => {
    const scope_list = this.state.scope_list.filter(tag => tag !== removedTag);
    this.setState({ scope_list });
  }

    //搜索组织架构
    getOrgApi(parentOrg_uuid){
        var _this=this;
        var params={
            access_token:_this.state.access_token,
            parent_uuid:parentOrg_uuid,
            page:1,
            page_size:9999
        }
        getOrg(params).then(res => {
        
          // console.log(res);
          if(res.code === 0){
            if(parentOrg_uuid===0){
               _this.setState({treeData:res.content.list})
            }else{
              _this.setState({childTreeData:res.content.list})
            }
          }else{
            message.error(res.message);
          }
    
        })
      }

    //改变用户权限---取消选中时有bug
    changeUserPrivilege = (value, label, extra) => {
        // console.log(value)
        // console.log(extra)
        var arr=this.state.scope_before_list;
        var str='';
        let obj=extra.triggerNode.props.dataRef;
        arr.push({"uuid":obj.uuid,"name":obj.name,"org_type":obj.org_type,"corp_id":obj.corp_id});
        str=JSON.stringify(arr)
        this.setState({scope:str,scope_before_list:arr,orgValue:value});
      }
  
      //一级一级获取组织架构，传入父级orgUuid
    onLoadData = TreeNode2 =>{
      let _this=this;
      return new Promise(resolve => {
        if (TreeNode2.props.children) {
          resolve();
          return;
        }
        getOrg({
            access_token:_this.state.access_token,
            parent_uuid:TreeNode2.props.dataRef.uuid,
            corp_id:TreeNode2.props.dataRef.corp_id,
            page:1,
            page_size:9999
        }).then(function(data) {
         if (data.code === 0) {
          TreeNode2.props.dataRef.children=data.content.list;
           _this.setState({
            treeData: [..._this.state.treeData],
           });
           resolve();
         }else {
           message.error(data.message);
         }
       })
      });
      }
  
    // TreeSelect树型选择控件
    renderTreeNodes = data => data&&data.map((item) => {
      if (item.children&&item.children.length) {
        return (
          <TreeNode title={item.name} key={item.uuid} value={item.uuid} type={item.org_type} corp_id={item.corp_id} dataRef={item}>
            {this.renderTreeNodes(item.children)}
          </TreeNode>
        );
      }
      return <TreeNode title={item.name} key={item.uuid} value={item.uuid} type={item.org_type} corp_id={item.corp_id} dataRef={item}/>;
    })
  
    onSearch = (e) => {
      let _this=this;
      let value=e.target.value;
      _this.setState({search_orgName:value})
    }

    //搜索组织架构
    onPressEnter= (flag,e) => {
      let _this=this;
      let value=_this.state.search_orgName;
      _this.setState({treeData:[],loading:false},()=>{
        var e = document.createEvent("MouseEvents");
        e.initEvent("click", true, true);
        if(flag==='range'){
            document.querySelector('#range .ant-select-selection').dispatchEvent(e); 
        }else if(flag==='range2'){
            document.querySelector('#range2 .ant-select-selection').dispatchEvent(e); 
        }
        if(value){
          getOrg({
            access_token:_this.state.access_token,
            key:value,
            page:1,
            page_size:9999
          }).then(function(data) {
            if (data.code === 0) {
              _this.setState({ treeData: data.content.list,loading:true});
            } else {
              message.error(data.message);
            }
          })
         }else{
            _this.getOrgApi(0);
         }
        
      })
    }

  // 点击取消按钮
  handleCancel = (e) => {
    this.props.cancelModal();//关闭弹窗
    this.setState({
        treeData: [],
        childTreeData: [],
        loading:false,
        search_orgName:'',
        orgValue:[],
        scope:'',
        scope_list:[],
        scope_before_list:[],
        params:{},
        inputVisible: false,
    })//清空数据
  }

    //修改员工权限框点击确定
    handleOk=(e)=>{
        var _this=this;
        var scope=_this.state.scope_list;//已有权限
        var arr=[];
        if(_this.state.scope){
          var _scope=JSON.parse(_this.state.scope);//新增权限
          scope.length&&scope.map((item)=>{
            let count=0;
            for(let i=0;i<_scope.length;i++){
              if(item.uuid!==_scope[i].uuid){
                 count++;
              }
            }
            if(count===_scope.length){
              arr.push(item)
            }
          })
           scope=arr.concat(_scope);
        }
        var params={
          access_token:_this.state.access_token,
          id:_this.props.details.id,
          role_uuid:_this.props.role_uuid,
          user_uuid:_this.props.details.user_uuid,
          scope:JSON.stringify(scope)
        }
        updateUser(params).then(res => {
          if(res.code === 0){
              _this.handleCancel();
              _this.props.getRoleUserList();//更新列表
          }else{
            message.error(res.message);
          }
        })
    }

  render() {
    const { visible } = this.props;
    const { loading, search_orgName, orgValue, scope_list } = this.state;

    const antIcon = <Icon type="loading" style={{ color: '#108ee9'}} spin/>;

    return (

       <div className='update_user_form'>

        <Modal
          title="更新角色用户权限范围"
          visible={visible}
          maskClosable={false}
          onOk={this.handleOk}
          onCancel={this.handleCancel}
          okText="确定"
          cancelText="取消"
        >
        <div>
          <div style={{marginLeft:30}}>
          {scope_list&&scope_list.length?
           <div>
            <p>修改已有权限：</p>
            {scope_list&&scope_list.map((item,index)=>{
                const tagElem = (
                  <Tag key={item.uuid} closable style={{marginTop:10}} color="blue" onClose={() => this.handleClose(item)}>
                    {item.name}
                  </Tag>
                );
                return tagElem;
            })}
           </div>:''
          }
          {this.state.inputVisible && (
            <div>
              <div style={{paddingTop:5, width:300, position:'relative', display:'inline-block'}} id="range2"> 
              <Input.Search placeholder="请输入组织名称" value={search_orgName} onChange={this.onSearch.bind(this)} onSearch={this.onPressEnter.bind(this,'range2')}/>
                <TreeSelect
                     showSearch={false}
                     value={orgValue}
                     onChange={this.changeUserPrivilege.bind(this)}
                     loadData={this.onLoadData.bind(this)}
                     treeCheckable={true}
                     showCheckedStrategy={SHOW_PARENT}
                     treeCheckStrictly={true}
                     searchPlaceholder='请选择组织架构'
                     style={{width:300,marginTop:5}} 
                     dropdownStyle={{height:300}}
                     getPopupContainer={() => document.getElementById('range2')}
                >
                   {loading||(!loading&&this.state.treeData&&this.state.treeData.length)?(this.renderTreeNodes(this.state.treeData)):(<TreeNode title={<Spin indicator={antIcon} size='small'/>} />)}
                </TreeSelect>
              </div>
            </div>
          )}
          {!this.state.inputVisible && (
              <Tag color="blue" style={{marginTop:10}} onClick={this.showTree}>
                  <Icon type="plus" /> 新增权限
              </Tag>
          )}
          </div>
        </div>
        </Modal>
             
      </div>
    );
  }
}

export default UpdateUserPrivilege;



// WEBPACK FOOTER //
// ./src/page/Privilege/components/updateUserPrivilege.js